import React from 'react'
import { connect, ReactReduxContext } from 'react-redux'

import { FiltersPreview } from '..'
import { DEFAULT_FILTERS } from '../../settings'
import { resetFilters, enableQueryOnFiltersChange, disableQueryOnFiltersChange } from '../../actions'
import { gettext } from '../../../../services'
import { showFiltersModal } from '../../modals'

const TYPE_NAME = gettext('Route type')

function propsEqual(prop1, prop2) {
    return (Array.isArray(prop1)) ? (
        JSON.stringify(prop1) === JSON.stringify(prop2)
    ) : (
        prop1 === prop2
    )
}

const RouteFiltersPreview = props => (
    <ReactReduxContext.Consumer>
        {({ store }) => (
            <>
                <FiltersPreview {...props} className="hidden-xs" />
                <FiltersPreview {...props} className="hidden visible-xs"
                    onClick={() => props.onClickXS(store) } />
            </>
        )}
    </ReactReduxContext.Consumer>
)

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ filters }) => ({
    adaptedFilterNames: Object.keys(filters).reduce((names, key) => {
        if (!propsEqual(filters[key], DEFAULT_FILTERS[key])) {
            switch (key) {
                case 'q':
                    names.push(gettext('Route title')); break
                case 'distance':
                    names.push(gettext('Length')); break
                case 'ascent':
                    names.push(gettext('Ascent')); break
                case 'categories':
                    names.push(gettext('Bike type')); break
                case 'surfaces':
                    names.push(gettext('Surface')); break
                case 'onlyLoop':
                    if (!names.includes(TYPE_NAME)) names.push(TYPE_NAME)
                    break
            }
        }

        return names
    }, []),
})

const mapDispatchToProps = dispatch => ({
    onReset: () => dispatch(resetFilters()),
    onClickXS: (store) => {
        showFiltersModal(store, () => dispatch(enableQueryOnFiltersChange()))
        dispatch(disableQueryOnFiltersChange())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(RouteFiltersPreview)
